<div class="page-shell">
  <div class="page-header">
    <div class="page-heading">
      <app-admin-back-button></app-admin-back-button>
      <div class="page-title-block">
        <h1>Mitarbeiterdetails</h1>
        <p>Allgemeine Informationen und Profileinstellungen</p>
      </div>
    </div>
  </div>

  @if (isLoading()) {
  <div class="loading-container">
    <mat-spinner></mat-spinner>
  </div>
  } @else if (employee(); as employee) {
  <div class="detail-grid">
    <mat-card>
      <mat-card-header class="detail-card-header">
        <mat-card-title>Allgemeine Informationen</mat-card-title>
        <button
          mat-flat-button
          color="primary"
          type="button"
          (click)="openGeneralDetailsDialog()"
        >
          Allgemeine Daten bearbeiten
        </button>
      </mat-card-header>
      <mat-card-content class="detail-list">
        <div>
          <span>External ID</span
          ><strong>{{ employee.externalIdentifier }}</strong>
        </div>
        <div>
          <span>Mitarbeiter ID</span><strong>{{ employee.employeeId }}</strong>
        </div>
        <div>
          <span>Vorname</span><strong>{{ employee.firstName || "—" }}</strong>
        </div>
        <div>
          <span>Nachname</span><strong>{{ employee.lastName || "—" }}</strong>
        </div>
        <div>
          <span>E-Mail</span><strong>{{ employee.email || "—" }}</strong>
        </div>
        <div>
          <span>E-Mail verifiziert</span
          ><strong>{{ asBoolean(employee.emailVerified) }}</strong>
        </div>
        <div>
          <span>Telefonnummer</span
          ><strong>{{ employee.phoneNumber || "—" }}</strong>
        </div>
        <div>
          <span>Benutzername</span
          ><strong>{{ employee.username || "—" }}</strong>
        </div>
        <div>
          <span>Typ</span><strong>{{ employee.type || "—" }}</strong>
        </div>
        <div>
          <span>Department</span
          ><strong>{{ employee.department || "—" }}</strong>
        </div>
        <div>
          <span>Kann Daten anderer lesen</span
          ><strong>{{ asBoolean(employee.canReadDataOfOthers) }}</strong>
        </div>
        <div>
          <span>Account aktiviert</span
          ><strong>{{ asBoolean(employee.enabled) }}</strong>
        </div>
      </mat-card-content>
    </mat-card>

    @if (settings(); as settings) {
    <mat-card>
      <mat-card-header class="detail-card-header">
        <mat-card-title>Profileinstellungen</mat-card-title>
        <button
          mat-flat-button
          color="primary"
          type="button"
          (click)="openSettingsDialog()"
        >
          Einstellungen bearbeiten
        </button>
      </mat-card-header>
      <mat-card-content class="detail-list">
        <div>
          <span>Anzeigesprache</span
          ><strong>{{ settings.displayLanguage || "—" }}</strong>
        </div>
        <div>
          <span>Bevorzugte Sprache</span
          ><strong>{{ settings.preferredLanguage || "—" }}</strong>
        </div>
        <div>
          <span>Foto-Countdown</span
          ><strong>{{ asSeconds(settings.photoCountdownSeconds) }}</strong>
        </div>
        <div>
          <span>Livebild-Dauer</span
          ><strong>{{ asSeconds(settings.liveImageDurationSeconds) }}</strong>
        </div>
        <div>
          <span>SMS-Ländercodes</span
          ><strong>{{
            asCountryCodes(settings.favoriteSmsCountryCodes)
          }}</strong>
        </div>
        <div>
          <span>Personeneingabe verpflichtend</span
          ><strong>{{ asBoolean(settings.makePersonInputMandatory) }}</strong>
        </div>
      </mat-card-content>
    </mat-card>
    }
  </div>
  }
</div>
